<template>
  <ul role="menubar" aria-disabled="false" aria-label="Pagination" class="pagination b-pagination b-pagination-pills">
    <!---->
    <li role="presentation" class="page-item">
      <button role="menuitem" type="button" class="page-link" @click="prevPage">
        <span v-show="value > 1">
          <img :src="require('@/assets/xh/images/prev_page.png')">
        </span>
      </button>
    </li>
    <li role="presentation" class="page-item" :class="[val=='...' ? 'disabled bv-d-xs-down-none':'', {active: value === val}]" v-for="(val, idx) in layoutList">
      <span class="ellipsis" v-if="val == '...'">...</span>
      <button role="menuitemradio" type="button" class="page-link" @click="changePage(val)" v-else>{{ val }}</button>
    </li>
    <!-- <li role="presentation" class="page-item">
      <button role="menuitemradio" type="button" aria-controls="filter-list" aria-label="Go to page 1" aria-checked="false" aria-posinset="1" aria-setsize="10" tabindex="-1" class="page-link">1</button>
    </li>
    <li role="separator" class="page-item disabled bv-d-xs-down-none">
      <span class="page-link">…</span>
    </li>
    <li role="presentation" class="page-item">
      <button role="menuitemradio" type="button" aria-controls="filter-list" aria-label="Go to page 8" aria-checked="false" aria-posinset="8" aria-setsize="10" tabindex="-1" class="page-link">8</button>
    </li>
    <li role="presentation" class="page-item active">
      <button role="menuitemradio" type="button" aria-controls="filter-list" aria-label="Go to page 9" aria-checked="true" aria-posinset="9" aria-setsize="10" tabindex="0" class="page-link">9</button>
    </li>
    <li role="presentation" class="page-item">
      <button role="menuitemradio" type="button" aria-controls="filter-list" aria-label="Go to page 10" aria-checked="false" aria-posinset="10" aria-setsize="10" tabindex="-1" class="page-link">10</button>
    </li> -->
    <!----><!---->
    <li role="presentation" class="page-item goto">
      <button role="menuitem" type="button" class="page-link" @click="nextPage">
        <span v-show="value < pageCount"><img :src="require('@/assets/xh/images/next_page.png')"></span>
      </button>
    </li>
    <li role="presentation" class="page-item goto">
      <button role="menuitem" type="button" class="page-link" @click="lastPage">
        <span v-show="value < pageCount"><img :src="require('@/assets/xh/images/last_page.png')"></span>
      </button>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'BasePagination',
  props: {
    pageCount: {
      type: Number,
      default: 0,
      description:
        "Pagination page count. This should be specified in combination with perPage"
    },
    perPage: {
      type: Number,
      default: 10,
      description:
        "Pagination per page. Should be specified with total or pageCount"
    },
    total: {
      type: Number,
      default: 0,
      description:
        "Can be specified instead of pageCount. The page count in this case will be total/perPage"
    },
    value: {
      type: Number,
      default: 1,
      description: "Pagination value"
    },
  },
  computed: {
    layoutList() {
      console.log('layoutList: ', this.value, this.pageCount)
      if ([1,2].includes(this.value) && this.pageCount > 0) {
        if (this.pageCount <= 3) {
          return this.range(1, this.pageCount)
        } else if (this.pageCount > 3 && this.pageCount <= 10) {
          return [1, 2, '...', this.pageCount]
        } else if (this.pageCount > 10) {

          let n = this.pageCount / 10;
          let arr = [];
          for (let i = 1; i <= n; i++) {
            if (i > 3) break
            arr.push(i*10)
          }

          if (this.pageCount > 31) {
            return [1, 2, '...', ...arr, '...', this.pageCount]
          } else {
            if (this.pageCount % 10 == 0) {
              return [1, 2, '...', ...arr]
            } else if (this.pageCount % 10 == 1) {
              return [1, 2, '...', ...arr, this.pageCount]
            } else {
              return [1, 2, '...', ...arr, '...', this.pageCount]
            }
          }

        }
      } else {
        if (this.pageCount < 7) {
          return this.range(1, this.pageCount)
        } else if (this.pageCount >= 7) {
          if (this.value <= 5) {
            let arr = this.range(1, 5)
            return [...arr, '...', this.pageCount]
          } else {
            if (this.pageCount - 1 > this.value) {
              return [1, 2, '...', this.value-1, this.value, this.value+1, '...', this.pageCount]
            } else if (this.pageCount - 1 == this.value) {
              return [1, 2, '...', this.value-1, this.value, this.pageCount]
            } else {
              return [1, 2, '...', this.value-1, this.value]
            }

          }
        }
      }

    }
  },
  data() {
    return {

    }
  },
  methods: {
    range(min, max) {
      let arr = [];
      for (let i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },
    changePage(item) {
      this.$emit("input", item);
    },
    nextPage() {
      if (this.value < this.pageCount) {
        this.$emit("input", this.value + 1);
      }
    },
    prevPage() {
      if (this.value > 1) {
        this.$emit("input", this.value - 1);
      }
    },
    lastPage() {
      this.$emit("input", this.pageCount)
    }
  },
  watch: {
    perPage() {
      this.$emit("input", 1);
    },
    total() {
      this.$emit("input", 1);
    }
  }
}
</script>

<style scoped>
  .ellipsis {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: 0.25rem;
    line-height: 1.25;
    background-color: #fff;
    border: none;
    letter-spacing: 0.3rem;
    color: black;
  }
  .goto {
    width: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/BasePagination.vue